import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaChevronDown,
  FaEnvelopeOpenText,
  FaQuestionCircle,
} from "react-icons/fa";
import Header from "./Header";
import Footer from "./Footer";
import "./FAQ.css";

const FAQS = [
  {
    question: "Is signing up on GoOurHub free?",
    answer: [
      "Yes. Creating a GoOurHub user account is completely free.",
      "Businesses can also submit a standard business listing. Vendors and businesses that want additional visibility, branding, and promotion can choose a premium listing.",
    ],
    list: [
      "See the Pricing page for current premium listing options.",
      "If you choose a paid service, payment is collected securely at checkout after you complete the sign-up form.",
    ],
  },

  {
    question: "What can I do on GoOurHub?",
    answer: [
      "GoOurHub is designed to bring local businesses, communities, events, deals, and marketplace listings together in one place.",
    ],
    list: [
      "Discover local businesses and services.",
      "Explore community information and local events.",
      "Find deals and promotions from participating businesses.",
      "Browse or post items through HubMart.",
      "Save your favorite listings for easier access later.",
      "Receive GoOurHub updates and notifications when available.",
    ],
  },

  {
    question: "How can I add my business to GoOurHub?",
    answer: [
      "Use the Add Business option on GoOurHub and submit your business information.",
      "We may review submitted information before the listing becomes publicly available to help keep the directory useful and accurate.",
    ],
    list: [
      "Provide accurate business contact and category information.",
      "Make sure your business name, phone number, website, and other details are current.",
      "You can choose available promotional or premium options if you want additional visibility.",
    ],
  },

  {
    question: "What is the difference between a free business listing and a premium listing?",
    answer: [
      "A standard listing helps your business appear in the GoOurHub directory.",
      "Premium listings are designed for businesses that want greater visibility and additional promotional opportunities on GoOurHub.",
    ],
    list: [
      "Premium options may include enhanced presentation, branding, and promotion.",
      "Available features and pricing are shown on the Pricing or Vendor Sign-Up pages.",
    ],
  },

  {
    question: "Can I post an event on GoOurHub?",
    answer: [
      "Yes. GoOurHub supports local event sharing so visitors can discover what is happening in the community.",
      "Use the event posting or submission option and provide complete information about your event.",
    ],
    list: [
      "Include the event name, date, time, location, and a clear description.",
      "Add an event image or flyer when that option is available.",
      "Make sure contact and registration information is accurate before submitting.",
    ],
  },

  {
    question: "Will an event appear immediately after I submit it?",
    answer: [
      "Event submissions may be reviewed before appearing publicly.",
      "This helps GoOurHub reduce incomplete, misleading, duplicate, or inappropriate event listings.",
    ],
    list: [
      "Approval time can vary depending on the information provided.",
      "Providing complete event details can help avoid unnecessary delays.",
    ],
  },

  {
    question: "Can I submit a correction if my event information changes?",
    answer: [
      "Yes. If an event date, location, time, or other important information changes, contact GoOurHub so the listing can be corrected.",
      "Please send the event name along with the information that needs to be updated.",
    ],
  },

  {
    question: "What is HubMart?",
    answer: [
      "HubMart is GoOurHub’s local marketplace area where visitors can discover items and opportunities posted by the community.",
    ],
    list: [
      "Browse available local listings.",
      "Search different HubMart categories.",
      "Post an item when you have something to offer.",
      "Contact the listing owner using the contact options provided with the listing.",
    ],
  },

  {
    question: "Do I need an account to post something on HubMart?",
    answer: [
      "GoOurHub may ask you to sign in or verify your email when creating a HubMart listing.",
      "These steps help us reduce spam and make marketplace listings more trustworthy.",
    ],
    list: [
      "Signed-in users may have a faster posting experience.",
      "Always provide a valid way for interested visitors to contact you.",
    ],
  },

  {
    question: "Does GoOurHub sell the items listed on HubMart?",
    answer: [
      "No. HubMart is a community marketplace where listings are posted by individual sellers or businesses.",
      "Unless specifically stated otherwise, GoOurHub is not the seller of the item being advertised.",
    ],
    list: [
      "Review a listing carefully before making an arrangement.",
      "Use good judgment when communicating or meeting with another person.",
      "Report suspicious or misleading listings to GoOurHub.",
    ],
  },

  {
    question: "Can I save businesses, events, or listings that I like?",
    answer: [
      "Yes. GoOurHub includes favorite and saved-item features in supported areas of the site.",
      "When you are signed in, look for the favorite or save option so you can quickly return to something later.",
    ],
  },

  {
    question: "What is the notification bell for?",
    answer: [
      "The notification bell gives you a convenient place to see GoOurHub alerts and updates associated with your account.",
      "When you have unread notifications, the bell may display an indicator letting you know something new is available.",
    ],
  },

  {
    question: "Where can I find local deals and promotions?",
    answer: [
      "GoOurHub highlights selected local offers, coupons, promotions, and special deals throughout the site.",
      "Offers are provided by participating businesses and may be available for a limited time.",
    ],
    list: [
      "Always review the details of an offer before using it.",
      "Individual businesses are responsible for their promotional terms and availability.",
    ],
  },

  {
    question: "How do I find businesses or services that interest me?",
    answer: [
      "Use GoOurHub’s search, categories, and community sections to explore businesses and services.",
      "Different parts of the site may also provide filters to help narrow your results.",
    ],
    list: [
      "Search by business or service name.",
      "Browse by business category.",
      "Explore community-focused sections.",
      "Check recently added and featured listings for new discoveries.",
    ],
  },

  {
    question: "What are the Communities sections on GoOurHub?",
    answer: [
      "The Communities area helps visitors discover businesses, organizations, events, and useful local information connected with different communities.",
      "The goal is to make local discovery easier while keeping everything connected through one hub.",
    ],
  },

  {
    question: "Is GoOurHub only for businesses?",
    answer: [
      "No. Businesses are an important part of GoOurHub, but the platform is designed for the wider community.",
    ],
    list: [
      "Residents can discover businesses and services.",
      "Visitors can find events and local activities.",
      "Community organizations can gain visibility.",
      "Users can browse HubMart and local deals.",
    ],
  },

  {
    question: "What should I do if I see incorrect or inappropriate information?",
    answer: [
      "Please let us know. Accurate and useful information is important to GoOurHub.",
      "Use the Contact Us page or email goourhub@gmail.com and include enough information for us to identify the listing or post.",
    ],
    list: [
      "Include the business, event, or listing name.",
      "Explain what information appears to be incorrect.",
      "For inappropriate or suspicious content, provide as much detail as possible.",
    ],
  },

  {
    question: "How do I contact GoOurHub for more complex needs?",
    answer: [
      "If you need something beyond the options currently available on the site, reach out through our Contact page or email us directly at goourhub@gmail.com.",
      "We’ll review your request and guide you toward the right next step.",
    ],
  },

  {
    question: "Will I receive an acknowledgment of my payment?",
    answer: [
      "Yes. Once your payment is successfully processed, you will receive a confirmation or acknowledgment.",
    ],
  },

  {
    question: "What if I change my mind after signing up for a paid service?",
    answer: [
      "You have a three-day window to withdraw your request.",
      "To cancel, email goourhub@gmail.com or submit your request through the Contact Us form in writing.",
    ],
  },

  {
    question: "Are the fees refundable?",
    answer: [
      "Fees are generally non-refundable once the setup process begins.",
    ],
    list: [
      "The exception is an eligible cancellation made within the three-day withdrawal period.",
    ],
  },

  {
    question: "What happens after I sign up and pay for a premium listing?",
    answer: [
      "Once your signup and payment are complete, here’s what to expect next:",
    ],
    list: [
      "You receive an acknowledgment.",
      "Your submitted business information and uploaded content are reviewed.",
      "If your materials meet GoOurHub’s quality and content standards, the listing moves into setup.",
      "When applicable, you receive a preview for proofreading and final approval before the completed listing goes live.",
    ],
  },

  {
    question:
      "If I choose a standard GoOurHub static page, do I still need to approve it?",
    answer: [
      "Not usually. Standard GoOurHub static pages can move through the process without a separate custom-design approval step.",
    ],
    list: [
      "You are still responsible for checking your business information for accuracy.",
      "If you notice anything incorrect, contact GoOurHub as soon as possible so corrections can be made.",
    ],
  },
];

function FAQPage() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="faq-page-shell">
      <Header />

      <main className="faq-page">
        <section className="faq-hero-card">
          <div className="faq-hero-copy">
            <span className="faq-kicker">Support &amp; answers</span>
            <h1>
              Frequently asked questions<span className="faq-accent">.</span>
            </h1>
            <p className="faq-intro">
              Get the key details about signup, payment, approvals, and next
              steps without digging through a mess.
            </p>
          </div>

          <div className="faq-help-card">
            <div className="faq-help-card__icon">
              <FaQuestionCircle />
            </div>
            <span className="faq-help-card__kicker">Still need help?</span>
            <h2>Need a direct answer?</h2>
            <p>
              For support, payment questions, or custom requests, contact us
              directly.
            </p>

            <a className="faq-inline-link" href="mailto:goourhub@gmail.com">
              <FaEnvelopeOpenText />
              <span>goourhub@gmail.com</span>
            </a>

            <Link to="/contact" className="faq-cta-btn">
              Contact Us
            </Link>
          </div>
        </section>

        <section className="faq-list-section">
          <div className="faq-list">
            {FAQS.map((faq, index) => {
              const isOpen = openIndex === index;

              return (
                <article
                  key={faq.question}
                  className={`faq-item ${isOpen ? "is-open" : ""}`}
                >
                  <button
                    type="button"
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-answer-${index}`}
                  >
                    <span className="faq-question__num">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="faq-question__text">{faq.question}</span>
                    <span className="faq-toggle-icon">
                      <FaChevronDown />
                    </span>
                  </button>

                  <div id={`faq-answer-${index}`} className="faq-answer-wrap">
                    <div className="faq-answer">
                      {faq.answer.map((paragraph, paragraphIndex) => (
                        <p key={paragraphIndex}>{paragraph}</p>
                      ))}

                      {faq.list && (
                        <ul className="faq-answer-list">
                          {faq.list.map((item, itemIndex) => (
                            <li key={itemIndex}>{item}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default FAQPage;
